import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import ScrollSnapBox from '../ScrollSnapBox';
import { Box } from '@mui/material';
import ReadMoreButton from '../ReadMoreButton';
import Logo from '../../assets/images/logo1.jpg';
import Image from '../../assets/images/who_we_are.png';
import Parter1 from '../../assets/images/partner1.png';
import Parter2 from '../../assets/images/partner2.png';
import Parter3 from '../../assets/images/partner3.png';

const WhoWeAre = () => {
    return (
    <ScrollSnapBox>
      {({ inView }) => (      
          <Box className='grid grid-cols-4 
          max-lg:grid-cols-2
          grid-rows-2 gap-4 md:gap-6 lg:gap-10 lg:my-10 px-6 sm:px-8 md:px-10 lg:px-20 mt-12 md:mt-16 lg:mt-20'
          >
            <Card sx={{
              gridRowStart: 'span 2',
              gridColumnStart: 'span 2',
              backgroundImage: `url(${Image})`, 
              backgroundSize: 'cover', // Ensures the image covers the card
              backgroundPosition: 'center', // Centers the image
              backgroundRepeat: 'no-repeat', // Prevents tiling
              filter: 'brightness(0.9)', 
            }}>
              <CardContent className='mt-4'>
                <div className="text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-4 text-theme-blue">
                  WHO WE ARE
                </div>
                <div className="space-y-2 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-700"> 
                  <div>
                    We are dedicated to providing innovative green energy solutions, empowering education, and expert consultancy to industries, organizations, and communities globally.
                  </div>
                  
                  <div>
                    Our goal is to make achieving net-zero emissions by 2050 an attainable reality through:
                  </div>
                  
                  <ul className="list-disc pl-8"> 
                    <li>
                      <span className='font-bold'>Innovation</span>: Developing cutting-edge technologies and strategies to reduce carbon emissions.
                    </li>
                    <li>
                      <span className='font-bold'>Education</span>: Raising awareness and equipping individuals with the knowledge to embrace sustainable practices.
                    </li>
                    <li>
                      <span className='font-bold'>Collaboration</span>: Partnering with businesses, governments, and researchers to drive impactful change.
                    </li>
                  </ul>
                  <div className="mt-8">
                    <ReadMoreButton to="/organization" />
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card sx={{
              width: '100%', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              border: 'none',
              boxShadow: 'none',
            }}>
              <CardMedia
                component="img" 
                sx={{ 
                  height: 120,    
                  width: '95%',      
                  objectFit: 'contain', 
                  objectPosition: 'center',
                }}
                image={Logo}
                title="logo"
              />
            </Card>


            <Card sx={{
              position: 'relative', 
              height: '100%',      
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden'     
            }}>
              {/* image */}
              <CardMedia
                sx={{ 
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  height: '100%',
                  filter: 'brightness(0.8)', 
                }}
                image="https://images.pexels.com/photos/1452701/pexels-photo-1452701.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                title="green sea"
              />

              {/* text */}
              <div className='my-8 md:my-12 lg:my-16'>
                <h2 className="relative text-white text-sm sm:text-base md:text-lg lg:text-xl text-center mb-2 md:mb-4 lg:mb-6">
                  Hydrogen for Green Planet
                </h2>
                <h3 className="relative text-white font-bold text-base sm:text-lg md:text-xl lg:text-2xl text-center">
                  Duralyze
                </h3>
              </div>

            </Card>

            <Card sx={{ gridColumnStart: 'span 2' }}>
              <CardContent>
                <div className="text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-4 text-theme-blue">
                  OUR PARTERS
                </div>
                <div className='flex flex-row lg:flex-col xl:flex-row justify-center items-center gap-2 lg:gap-4 xl:gap-6'>
                  <img src={Parter2} alt="Duralyze partner logo" className="h-10 sm:h-16 md:h-24 lg:h-16 3xl:h-24" />
                  <img src={Parter3} alt="Duralyze partner logo" className="h-16 sm:h-24 md:h-36 lg:h-36 3xl:h-48"/>
                  <img src={Parter1} alt="Duralyze partner logo" className="h-10 sm:h-16 md:h-24 lg:h-16 3xl:h-24" />
                </div>
              </CardContent>
            </Card>
          </Box>
        
      )}
    </ScrollSnapBox>
  )
}

export default WhoWeAre;
